import extractIdFromGid from "helpers/extract-gid";

const getInfluenceDigest = async (emailAddress, id) => {
	try {
		const response = await fetch("/.netlify/functions/generate-customer-digest", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ emailAddress, id: extractIdFromGid(id) }),
		});

		const data = await response.json();
		return data.digest;
	} catch (error) {
		console.error("Error fetching digest:", error);
		return null;
	}
};

export default getInfluenceDigest;